<template>
	<div class="image-upload-container">
		<div class="hint">
			<label v-if="label" >{{ label }}</label>
			<CommonHint v-if="hint">
				<template v-slot:hint>
					<slot name="hint">

					</slot>
				</template>
			</CommonHint>
		</div>
		<div :class="`image-uploader ${isBig ? 'big' : ''}`" @dragover.prevent @drop.prevent>
			<input
				class="input-image"
				type="file"
				:accept="acceptList"
				v-on:change="uploadImageWithClick"
				ref="imageInput"
			>
			<label
				class="uploader-section"
				@click="$refs.imageInput.click()"
				@drop="uploadImageWithDrop"
				v-if="previewUrl?.trim?.() === ''"
			>
				<span class="uploader-label">
					<img class="uploader-image" src="@/drc/assets/icons/image-upload-black.svg" alt="image">
					<span>{{ uploadText || $t('projectFroms.uploadFile') }}</span>
				</span>
			</label>
			<span :class="['preview', 'large', {'error-border' : formData[field].errors.length > 0}]" v-if="previewUrl?.trim?.() !== ''">
				<img
					class="close"
					src="@/drc/assets/icons/x-with-cicle.svg"
					width="18"
					height="18"
					alt="close"
					@click="removeImage"
				>
				<img :src="previewUrl" class="preview-image" ref="imagePreview" alt="logo"/>
			</span>
			<div class="image-upload-error" v-if="formData[field].errors.length > 0">
				<span v-for="(error, index) in formData[field].errors" :key="index">
					{{ $t(`${error}`)+'.' }}
				</span>
			</div>
		</div>
	</div>
</template>

<script>
import {validateField} from "@/drc/pages/submit-form/submission-service";
import CommonHint from "@/drc/pages/submit-form/components/CommonHint.vue";

export default {
	name: "CommonImageUpload",
	components: {
		CommonHint
	},
	props: {
		field: {
			type: String,
			required: true
		},
		formData: {
			type: Object,
			required: true
		},
		label: {
			type: String,
			required: false,
			default: ''
		},
		hint: {
			type: Boolean,
			required: false
		},
		uploadText: {
			type: String,
			default: null
		},
		isBig: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			previewUrl: '',
			imageData: null,
			dataType: '',
			height: 0,
			width: 0,
			image: null
		}
	},
	watch: {
		data: {
			handler: function () {
				this.getNameAndSrc();
			},
			deep: true
		}
	},
	computed: {
		acceptList() {
			return this.formData[this.field].validations.map(el => el.allowedTypes).filter(el => el).join(', ')
		}
	},
	mounted() {
		this.getNameAndSrc();
	},
	methods: {
		getNameAndSrc() {
			if(this.formData[this.field].value){
				const vue = this;
				const image = new Image();

				if(typeof this.formData[this.field].value === "string") {
					this.previewUrl = this.formData[this.field].value;
				}

				image.src = this.formData[this.field].value;
				image.onload = function () {
					vue.image = this;
					vue.height = this.height;
					vue.width = this.width;
					vue.validate(false);
				};
			}
		},
		uploadImageWithDrop(event) {
			this.uploadImage(event.dataTransfer.files[0]);
		},
		uploadImageWithClick(event) {
			this.uploadImage(event.target.files[0]);
		},
		uploadImage(file) {
			// this.formData[this.field].errors = [];
			const reader = new FileReader();
			const vue = this;
			reader.onload = (event) => {
				vue.previewUrl = event.target.result;
				const image = new Image();
				image.src = event.target.result;
				image.onload = function () {
					vue.image = this;
					vue.height = this.height;
					vue.width = this.width;
					vue.dataType = vue.fileData.type
					vue.validate(false);
				};
			}

			this.fileData = file;

			if(!this.acceptList.split(',').includes(this.fileData.type)){
				this.formData[this.field].errors = ['submissionForm.validateFileType'];
			}else {
				reader.readAsDataURL(this.fileData);
				this.imageData = new FormData();
				const fileName = this.parseImageName(this.fileData.name);
				this.imageData.append('file', this.fileData, fileName);
				this.formData[this.field].value = this.imageData;
				// vue.validate(false);
			}
		},
		validate(scroll = true) {
			validateField(this.formData, this.field);
		},
		parseImageName(fileName) {
			fileName = fileName.trim().replaceAll(/\s/g, "-");
			fileName = fileName.replace('%', '-')
			return fileName;
		},
		removeImage() {
			this.previewUrl = "";
			this.formData[this.field].value = null
			this.fileData = undefined;
			this.$refs.imageInput.type = 'text'
			this.$refs.imageInput.type = 'file'
			this.image = null
			this.imageData = null
			this.validate(false);
		},
	}
}
</script>

<style lang="scss" scoped>
@import "@/common/assets/css/_variables.scss";

.image-upload-container {
	margin-top: 20px;
	margin-bottom: 20px;

	.hint {
		label {
			color: #FCFCFE;
			flex-basis: 20%;
			font-family: Roboto, serif;
			font-weight: 600;
			font-size: 17px;
			line-height: 22px;
			letter-spacing: 0;
		}
	}

	.image-uploader {
		padding-top: 5px;
		display: flex;
		position: relative;

		&.big {
			.preview-image{
				height: 20rem;
			}
		}

		.preview-image {
			height: calc(10rem - 20px);
			width: auto;
		}

		.uploader-section {
			padding: 30px;
			background: white;
			height: 10rem;
			width: 10rem;
			border-radius: 5px;
			margin-right: 1rem;
			text-align: center;
			cursor: pointer;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;

			.uploader-label {
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				margin: 0 auto;

				.uploader-image {
					min-height: 50px;
				}

				span {
					display: block;
					margin-top: 10px;
					color: black;
					text-decoration: underline;
				}
			}
		}

		.input-image {
			display: none;
		}

		.preview {
			display: inline-block;
			overflow: visible;
			border: 1px solid $light-grey;
			border-radius: 5px;
			padding: 10px;
			position: relative;
			margin-bottom: 0;
			height: fit-content;

			.close {
				position: absolute;
				top: -7.5px;
				right: -7.5px;
				width: 20px;
				height: 20px;
				cursor: pointer;

				&:hover {
					transform: scale(1.1);
				}
			}
		}

		.error-border {
			border: 1px solid #FF453A;
		}
	}

	.image-upload-error {
		top: 100%;
		position: absolute;
		color: #FF453A;
		margin: 0;
		font-size: 14px;
		font-weight: 500;
		font-family: "Roboto", sans-serif;
		max-height: 15px;
	}

	.error-button {
		cursor: not-allowed;
		background: $color-grey;
		color: $color-gray-6;
		border: 1px solid $color-grey;
	}
}
</style>
